export default __webpack_public_path__ + "static/reportSlide-75b2352eb5e842662070610e8a864c8a.png";